export default __webpack_public_path__ + "static/ContactFormTextAndImage_V2-eb4538cdbb28cfb848450dbe19c61a05.jpg";